<script>
  import { mailDeliveryStore } from "../lib/upload";
  import { fileUploadStore } from "../lib/upload";
  import Spinner from "../UI/Spinner.svelte";
  import { fade, scale } from "svelte/transition";
  import moment from "moment";
  import { onMount } from "svelte";

  const { imageLoading, imageError, getImageUrl } = fileUploadStore;

  const { mailLoading, mailError, sendMail } = mailDeliveryStore;

  let fileInput;
  let lastInquiryDate = false;
  let showForm = false;
  let tooSoon = false;
  let imageName;
  let upload = null;
  let firstName = "";
  let lastName = "";
  let email = "";
  let phone = "";
  let message = "";

  $: emailSent = false;

  $: imgName = imageName;
  $: imgSuccess = upload;

  const momentLocal = moment().local().format("MM-DD-YYYY, h:mma");

  const submitEmail = async () => {
    const payload = {
      name: firstName.trim() + " " + lastName.trim(),
      phone: phone.trim(),
      message: message.trim(),
      email: email.trim(),
      time: momentLocal,
    };
    if (upload) payload["upload"] = upload;
    if (emailSent) return;
    try {
      const isSuccess = await sendMail(payload);
      if (isSuccess) emailSent = true;
      if (!isSuccess) throw new Error("wasnt successfully sent");
    } catch (err) {
      console.log(err);
    } finally {
      const rightNow = moment().local();
      const userData = {
        firstName,
        lastName,
        email,
        phone,
        lastInquiry: rightNow,
      };
      const stringified = JSON.stringify(userData);
      localStorage.setItem("maesInquiry", stringified);
    }
  };

  const onFileSelected = async (e) => {
    const image = e?.target?.files?.[0];
    if (!image) return;
    imageName = image.name;
    try {
      const compressedURL = await getImageUrl(image);
      console.log("compressedURL", compressedURL);
      upload = compressedURL;
    } catch (err) {
      console.log(err);
    }
  };

  onMount(() => {
    const userData = localStorage.getItem("maesInquiry");
    const parsedUserData = JSON.parse(userData);
    if (!userData) {
      showForm = true;
      return;
    }

    firstName = parsedUserData.firstName;
    lastName = parsedUserData.lastName;
    email = parsedUserData.email;
    phone = parsedUserData.phone;
    const lastEmail = parsedUserData.lastInquiry;
    const timeFromLastInquiry = moment(lastEmail).fromNow();
    lastInquiryDate = timeFromLastInquiry;
    // const timeFromLastArray = timeFromLastInquiry.split(" ");
    // for (let i = 0; i < timeFromLastArray.length; i++) {
    //   const eachItem = timeFromLastArray[i];
    //   if (
    //     eachItem === "minutes" ||
    //     eachItem === "hours" ||
    //     eachItem === "seconds"
    //   )
    //     tooSoon = true;
    // }
    showForm = true;
  });
</script>

<body>
  {#if emailSent || tooSoon}
    <div
      class="segment text-3xl center-screen flex flex-col gap-3"
      in:scale={{ duration: 1000 }}
    >
      <p>Thanks {firstName}!</p>
      <p>I'll get back to you as soon as possible.</p>
    </div>
  {:else if showForm}
    <form
      on:submit|preventDefault={submitEmail}
      in:scale={{ duration: 1000 }}
      out:fade={{ duration: 1000 }}
    >
      <div class="segment">
        <h1 class="font-2xl font-bold">Contact me</h1>
        {#if lastInquiryDate}
          <h3>Your last inquiry was {lastInquiryDate}</h3>
        {/if}
      </div>

      <label for="first-name">
        <input
          required
          type="text"
          maxlength="20"
          name="first-name"
          bind:value={firstName}
          id="first-name"
          autocomplete="given-name"
          placeholder="First Name"
        />
      </label>
      <label for="last-name">
        <input
          required
          type="text"
          bind:value={lastName}
          name="last-name"
          maxlength="20"
          autocomplete="family-name"
          id="last-name"
          placeholder="Last Name"
        />
      </label>
      <label for="email-input">
        <input
          required
          type="email"
          bind:value={email}
          name="email-input"
          id="email-input"
          placeholder="Email Address"
        />
      </label>
      <label for="phone">
        <input
          required
          autocomplete="tel"
          type="tel"
          bind:value={phone}
          name="phone"
          id="phone"
          placeholder="Phone Number"
        />
      </label>
      <label for="message">
        <textarea
          required
          bind:value={message}
          maxlength="200"
          id="message"
          name="message"
          rows="3"
          placeholder="Message"
        />
      </label>

      <div class="flex flex-col gap-3 items-end align-middle">
        <label class="img-upload-label cursor-pointer"
          ><div class={$imageLoading && !$imageError ? "" : ""}>
            {#if $imageLoading && !$imageError}
              <div in:fade={{ duration: 1000 }}>
                <Spinner />
              </div>
            {:else}
              <svg
                class="w-8 h-8"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                in:fade={{ duration: 1000 }}
              >
                <path
                  d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                />
              </svg>
            {/if}
          </div>

          <p class="text-base leading-normal ml-3 image-upload-text">
            {$imageLoading
              ? "Uploading..."
              : $imageError
              ? "Upload Error"
              : imgSuccess
              ? "Image Attached!"
              : "Upload an Image"}
          </p>
          <input
            accept=".png, .jpg, .jpeg, .gif, .heic, .heif"
            on:change={(e) => {
              onFileSelected(e);
            }}
            bind:this={fileInput}
            type="file"
            class="hidden"
          />
        </label>
        {#if imgName}
          <div class="flex items-start align-middle text-xs" in:scale out:fade>
            <p>{imgName}</p>
          </div>
        {/if}
      </div>

      <button class="red mb-32 mt-4" type="submit"
        >{$mailLoading
          ? "Sending..."
          : $mailError
          ? "Send error..."
          : emailSent
          ? "Success!"
          : `Let's talk`}</button
      >
    </form>
  {/if}
</body>

<style>
  :root {
    --ruler: 16px;
    --color-red: #ae1100;
    --color-bg: #ebecf0;
    --color-shadow: #babecc;
    --color-white: #fff;
  }

  body {
    background-color: var(--color-bg);
  }

  div,
  p {
    color: var(--color-shadow);
    text-shadow: 1px 1px 1px var(--color-white);
  }

  form {
    padding: var(--ruler);
    width: calc(var(--ruler) * 20);
    margin: 0 auto;
  }

  .segment {
    padding: calc(var(--ruler) * 2) 0;
    text-align: center;
  }

  button,
  input {
    border: 0;
    outline: 0;
    font-size: var(--ruler);
    border-radius: calc(var(--ruler) * 20);
    padding: var(--ruler);
    background-color: var(--color-bg);
    text-shadow: 1px 1px 0 var(--color-white);
  }

  textarea {
    border: 0;
    outline: 0;
    font-size: var(--ruler);
    border-radius: 1.5rem;
    padding: var(--ruler);
    background-color: var(--color-bg);
    text-shadow: 1px 1px 0 var(--color-white);
  }

  .center-screen {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  label {
    display: block;
    margin-bottom: calc(var(--ruler) * 1.5);
    width: 100%;
  }

  .img-upload-label {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    margin-bottom: 0;
    width: 100%;
    color: #61677c;
    font-weight: bold;
    box-shadow: -5px -5px 20px var(--color-white),
      5px 5px 20px var(--color-shadow);
    transition: all 0.2s ease-in-out;
    border-radius: calc(var(--ruler) * 20);
    padding: var(--ruler);
    background-color: var(--color-bg);
  }

  .image-upload-text {
    text-shadow: 1px 1px 0 var(--color-white);
  }

  .image-upload-text:hover {
    text-shadow: 1px 1px 0 var(--color-white);
  }

  .img-upload-label:hover {
    box-shadow: -2px -2px 5px var(--color-white, 2px 2px 5px var(--color-shadow));
  }

  input,
  textarea {
    margin-right: calc(var(--ruler) / 2);
    box-shadow: inset 2px 2px 5px
      var(--color-shadow, inset -5px -5px 10px var(--color-white));
    width: 100%;
    box-sizing: border-box;
    transition: all 0.2s ease-in-out;
    appearance: none;
    -webkit-appearance: none;
  }
  input:focus {
    box-shadow: inset 1px 1px 2px
      var(--color-shadow, inset -1px -1px 2px var(--color-white));
  }
  textarea:focus {
    box-shadow: inset 1px 1px 2px
      var(--color-shadow, inset -1px -1px 2px var(--color-white));
  }

  button {
    color: #61677c;
    font-weight: bold;
    box-shadow: -5px -5px 20px var(--color-white),
      5px 5px 20px var(--color-shadow);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    font-weight: 600;
  }

  button:hover {
    box-shadow: -2px -2px 5px var(--color-white, 2px 2px 5px var(--color-shadow));
  }

  button:active {
    box-shadow: inset 1px 1px 2px
      var(--color-shadow, inset -1px -1px 2px var(--color-white));
  }

  .red {
    display: block;
    width: 100%;
    color: var(--color-red);
  }
</style>
